import * as types from './actionTypes';
import {ORIGINATIONS_APP_BASE_URL} from '../constants/global';
import {generateURL} from '../api/urlHelper';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import {fetchParams} from '../constants/fetchParams';

export function receivePipeline(json) {
  return {type: types.RECEIVE_PIPELINE, pipeline: json.applications};
}

export function paginatePipeline(json) {
  return {
    type: types.PAGINATE_PIPELINE,
    pipelinePagination: {
      totalPages: json.meta.total_pages,
      currentPage: json.meta.current_page
    }
  };
}

export function fetchPipeline(params) {
  return dispatch => {
    return authenticatedFetch(pipelineURL(params), fetchParams())
    .then(response => response.json())
    .then(json => {
      dispatch(receivePipeline(json));
      dispatch(paginatePipeline(json));
      dispatch(handlePipelineError(false));
    })
    .catch(() => {
      dispatch(handlePipelineError(true));
    });
  };
}

export function handlePipelineError(bool) {
  return {
    type: types.HANDLE_PIPELINE_ERROR,
    pipelineError: bool
  };
}

export function pipelineURL(params) {
  let url = `${ORIGINATIONS_APP_BASE_URL()}applications`;
  return generateURL(url, params);
}

export function exportAndSavePipeline(csv) {
  return {
    type: types.EXPORT_AND_SAVE_PIPELINE,
    data: csv
  };
}

export function exportPipeline(params){
  return dispatch => {
    return authenticatedFetch(pipelineExportURL(params), {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.text())
    .then(csv => {
      dispatch(exportAndSavePipeline(csv));
    });
  };
}

export function pipelineExportURL(params) {
  let url = `${ORIGINATIONS_APP_BASE_URL()}applications.csv`;
  return generateURL(url, params);
}
